import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";

export enum EventType {
  PAGE_VIEW = "PAGE_VIEW",
  purchase = "PURCHASE",
  ADD_CART = "ADD_CART",
  checkout = "START_CHECKOUT",
  VIEW_CONTENT = "VIEW_CONTENT",
  view_item_list = "LIST_VIEW",
  ADD_BILLING = "ADD_BILLING",

  //new events for GA and GTM
  view_cart = "view_cart",
  remove_from_cart = "remove_from_cart",
  add_shipping_info = "add_shipping_info",
  userLogin = "userLogin",
  search_event = "search_event",
  maillist_conversion = "maillist_conversion",
  // added cross-tracker events
  search = "search",
  add_to_wishlist = "add_to_wishlist",
  lead = "lead",
  contact = "contact",
  complete_registration = "complete_registration",
}
export enum Tracker {
  FBP = "Facebook-Pixel",
  SCP = "Snapchat-Pixel",
  GTAG = "Google-Tag",
  GA = "Google-Analytics",
  TIK = "Tiktok-pixel",
  X = "X-Pixel",
}

export type GtagActionField = {
  currency?: string;
  value?: number;
  discount?: number;
  coupon?: string;
  shipping?: number;
  transaction_id?: string;
  tax?: number;
  item_list_id?: string;
  item_list_name?: string;
  shipping_tier?: string;
  payment_type?: string;
  // Non-ecommerce
  search_string?: string;
  // Invoice details for purchase events
  invoice_id?: string | number;
  invoice_number?: string;
  invoice_date?: string;
  invoice_time?: string;
  event_name?: string;
  city_name?: string;
  area_name?: string;
  country_name?: string;
  // When true, value is already converted by the backend — skip getPriceString
  skipConversion?: boolean;
};

export type SnapchatActionField = {
  transaction_id?: string;
  currency: string;
  price: number;
  discount?: number;
  item_ids: string[];
  number_items: number;
  user_email?: string;
  user_hashed_email?: string;
  user_phone_number?: string;
  user_hashed_phone_number?: string;
  firstname?: string;
  lastname?: string;
};
export type FacebookActionField = {
  currency: string;
  value: number;
  discount?: number;
  content_ids: string[];
  content_type?: string;

  // Non-ecommerce
  search_string?: string;

  email?: string;
  email_hash?: string;
  phone?: string;
  phone_hash?: string;
  external_id?: string;
  client_ip_address?: string;
  client_user_agent?: string;
  fbc?: string; // Facebook click ID
  fbp?: string; // Facebook browser ID

  // Invoice details for purchase events
  invoice_id?: string;
  invoice_number?: string;
  invoice_date?: string;
  invoice_time?: string;
  // eventID?: string;
};
export type TiktokActionField = {
  currency: string;
  value: number;
  content_type?: string;
  contents?: Array<{
    content_id: string;
    content_type: string;
    content_name?: string;
    price?: number;
    quantity?: number;
  }>;
  order_id?: string;
  // Non-ecommerce
  query?: string;
};

export type XActionField = {
  currency: string;
  value: number;
  conversion_id?: string;
  contents?: Array<{
    content_id?: string;
    content_name?: string;
    content_price?: number | string;
    num_items?: number | string;
  }>;
  search_string?: string;
  description?: string;
  status?: string;
  email_address?: string;
  phone_number?: string;
};

export type EventItem = {
  parent: { name: string; sku: string };
  type: ProductPreviewTypes;
  inner_id: number;
  name: string;
  discount: number;
  id?: number;
  price: number;
  quantity: number;
  attrs_values?: {
    id?: number;
    name: string;
    type?: string;
    key?: string;
  }[];
  categories_names?: string[];
};

export interface IGTagUserData {
  name?: string;
  email?: string;
  email_hash?: string;
  phone?: string;
  phone_hash?: string;
  user_id?: string | number;
}
